'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _memoWithDisplayName = require('../utils/memoWithDisplayName');

var _memoWithDisplayName2 = _interopRequireDefault(_memoWithDisplayName);

var _IconConstants = require('./IconConstants');

var _UIIcon = require('./UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Outer = _styledComponents2.default.span.withConfig({
  displayName: 'UIIconHolder__Outer'
})(['display:inline-flex;font-size:', ';line-height:1;padding:', ';transform:', ';user-select:none;position:relative;&.private-icon-circle--legacy{display:inline-flex;align-items:center;height:2em;justify-content:center;width:2em;}'], function (_ref) {
  var size = _ref.size;
  return size != null && (_IconConstants.ICON_SIZES[size] || size) + 'px';
}, function (_ref2) {
  var padding = _ref2.padding;
  return padding != null && padding + 'em';
}, function (_ref3) {
  var rotate = _ref3.rotate;
  return rotate != null && 'rotate(' + rotate + 'deg)';
});

var getIconTransform = function getIconTransform(_ref4) {
  var rotate = _ref4.rotate,
      rotateLock = _ref4.rotateLock;
  return rotate != null && !rotateLock ? 'rotate(' + rotate * -1 + 'deg)' : null;
};

var Icon = (0, _styledComponents2.default)(function (props) {
  var __rotate = props.rotate,
      __rotateLock = props.rotateLock,
      rest = _objectWithoutProperties(props, ['rotate', 'rotateLock']);

  return _react2.default.createElement(_UIIcon2.default, rest);
}).withConfig({
  displayName: 'UIIconHolder__Icon'
})(['height:1em;width:1em;margin:0.25em 0.125em 0;transform-origin:50% 38%;transform:', ' translateY(-6.3%);'], getIconTransform);

var UIIconHolder = (0, _memoWithDisplayName2.default)('UIIconHolder', function (_ref5) {
  var backgroundColor = _ref5.backgroundColor,
      borderColor = _ref5.borderColor,
      borderRadius = _ref5.borderRadius,
      borderStyle = _ref5.borderStyle,
      borderWidth = _ref5.borderWidth,
      color = _ref5.color,
      innerClassName = _ref5.innerClassName,
      innerStyles = _ref5.innerStyles,
      name = _ref5.name,
      rotate = _ref5.rotate,
      rotateLock = _ref5.rotateLock,
      size = _ref5.size,
      style = _ref5.style,
      verticalAlign = _ref5.verticalAlign,
      rest = _objectWithoutProperties(_ref5, ['backgroundColor', 'borderColor', 'borderRadius', 'borderStyle', 'borderWidth', 'color', 'innerClassName', 'innerStyles', 'name', 'rotate', 'rotateLock', 'size', 'style', 'verticalAlign']);

  return _react2.default.createElement(
    Outer,
    _extends({}, rest, {
      rotate: rotate,
      size: size,
      style: _extends({
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderRadius: borderRadius,
        borderStyle: borderStyle,
        borderWidth: borderWidth,
        verticalAlign: verticalAlign
      }, style)
    }),
    _react2.default.createElement(Icon, {
      className: innerClassName,
      color: color,
      name: name,
      rotate: rotate,
      rotateLock: rotateLock,
      size: size,
      style: innerStyles
    })
  );
});

UIIconHolder.propTypes = {
  backgroundColor: _propTypes2.default.string,
  borderColor: _propTypes2.default.string,
  borderRadius: _propTypes2.default.string,
  borderStyle: _propTypes2.default.oneOf(['solid', 'double', 'dashed', 'dotted', 'initial', 'inherit', 'unset']),
  borderWidth: _propTypes2.default.number,
  verticalAlign: _propTypes2.default.string,
  classname: _propTypes2.default.string,
  color: _UIIcon2.default.propTypes.color,
  innerClassName: _propTypes2.default.string,
  name: _UIIcon2.default.propTypes.name,
  padding: _propTypes2.default.number,
  rotate: _propTypes2.default.number,
  rotateLock: _propTypes2.default.bool,
  size: _UIIcon2.default.propTypes.size,
  innerStyles: _propTypes2.default.object
};

UIIconHolder.defaultProps = {
  padding: 0.5,
  rotate: 0,
  borderStyle: 'solid',
  borderWidth: 0
};

exports.default = UIIconHolder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/icon/UIIconHolder.js
// module id = 117
// module chunks = 177